<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Controle de Acesso</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Módulos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>

              <table v-if="!loadingList" class="table mb-0">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0 text-left">Descrição</th>
                    <th scope="col" class="border-0 text-left">Aplicação</th>
                    <th scope="col" class="border-0 text-left">Área</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(module, index) in Modules" :key="index">
                    <td></td>
                    <td class="text-left">{{ module.Name }}</td>
                    <td class="text-left">{{ module.Description }}</td>
                    <td class="text-left">{{ module.Application.Name }}</td>
                    <td class="text-left">{{ module.Area.Name }}</td>
                    <td></td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('AccessControl', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenMModule($event, module.Id, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('AccessControl', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenMModule($event, module.Id)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('AccessControl', 'Delete')"
                            class="dropdown-item disabled"
                            href="#"
                            v-on:click="ProcessDelete(module.Name, module.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      Modules == undefined ||
                      Modules == null ||
                      Modules.length == 0
                    "
                  >
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      id="mFormModule"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <ValidationObserver tag="form" ref="ControllerValidationForm">
          <d-form-row>
            <d-col md="6" class="form-group">
              <label for="inputControllerName">Controller</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  v-model="module.Name"
                  :class="validatedModuleForm | showValidateError(invalid)"
                  type="text"
                  id="inputControllerName"
                  v-bind:disabled="isSeeing"
                  placeholder="PaymentMethod"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedModuleForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label for="inputDescription">Descrição</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  v-model="module.Description"
                  :class="validatedModuleForm | showValidateError(invalid)"
                  type="text"
                  id="inputDescription"
                  v-bind:disabled="isSeeing"
                  placeholder="Formas de Pagamento"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedModuleForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Aplicação</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-select
                  :class="validatedModuleForm | showValidateError(invalid)"
                  v-model="module.Application.Code"
                  :disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="app in applications"
                    v-bind:value="app.Code"
                    v-bind:key="app.Code"
                  >
                    {{ app.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedModuleForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Área</label>
              <d-select
                v-model="module.Area.Code"
                :disabled="isSeeing || !module.Application.Code"
              >
                <option :value="null" selected>Selecione</option>
                <option
                  v-for="area in areasFiltered"
                  v-bind:value="area.Code"
                  v-bind:key="area.Code"
                >
                  {{ area.Name }}
                </option>
              </d-select>
            </d-col>
          </d-form-row>
        </ValidationObserver>

        <h5 class="card-title">Controle de Acesso</h5>
        <hr />

        <d-form-row>
          <d-col md="6" class="form-group">
            <d-form-checkbox
              v-model="module.IsIntegrationAccess"
              v-bind:disabled="isSeeing"
              id="checkIntegrationAccess"
              >Integração</d-form-checkbox
            >
          </d-col>
          <d-col md="6" class="form-group">
            <d-form-checkbox
              v-model="module.IsInterfaceView"
              v-bind:disabled="isSeeing"
              id="checkInterfaceView"
              >Interface</d-form-checkbox
            >
          </d-col>
        </d-form-row>

        <h5 class="card-title">Ações</h5>
        <hr />

        <ValidationObserver tag="form" ref="ActionsValidationForm">
          <d-form-row v-if="!isSeeing">
            <d-col md="11" class="form-group">
              <label for="dropActions">Ações</label>
              <ValidationProvider
                vid="selected_action"
                rules="required"
                v-slot="{ errors, invalid }"
              >
                <d-select
                  v-model="selected_action"
                  :class="validatedActionForm | showValidateError(invalid)"
                  :value="null"
                  id="dropActions"
                  v-bind:disabled="isSeeing"
                >
                  <option :value="null" selected>Selecione</option>
                  <option
                    v-for="action in action_list"
                    v-bind:key="action.Code"
                    v-bind:value="action.Code"
                  >
                    {{ action.Name }}
                  </option>
                </d-select>
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedActionForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

            <d-col md="1" class="form-group">
              <label for="btnAddAction">&nbsp;</label>
              <b-button
                variant="primary"
                id="btnAddAction"
                @click="AddAction()"
                v-bind:disabled="isSeeing"
              >
                <i class="fas fa-plus"></i>
              </b-button>
            </d-col>
          </d-form-row>
        </ValidationObserver>

        <table class="table mb-0" v-if="module.Actions.length > 0">
          <thead class="bg-s2p-gray-light">
            <tr>
              <th scope="col" class="border-0">{{ labelName }}</th>
              <th scope="col" class="border-0">Descrição</th>
              <th scope="col" class="border-0" v-if="!isSeeing"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(action, index) in action_list"
              v-if="IsOnSelectedActionsList(action.Code)"
              :key="index"
            >
              <td>{{ action.Name }}</td>
              <td>{{ action.Description }}</td>

              <td v-if="!isSeeing">
                <div class="text-right">
                  <b-button @click="RemoveAction(action.Code)">
                    <i class="fas fa-trash-alt" />
                  </b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="CreateOrUpdate()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeApplication" :value="null">
            <option :value="0" selected>Aplicação</option>
            <option
              v-for="app in applications"
              v-bind:key="app.Code"
              v-bind:value="app.Code"
            >
              {{ app.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeArea" :value="null">
            <option :value="0" selected>Área</option>
            <option
              v-for="area in areasFiltered"
              v-bind:key="area.Code"
              v-bind:value="area.Code"
            >
              {{ area.Name }}
            </option>
          </d-select>
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('AccessControl', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo módulo"
      v-on:click="OpenMModule($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "access-controls",
  data: function () {
    return {
      modalTitle: "Novo Módulo",
      labelName: "Controller",
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      countFilter: 0,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Name: null,
        CodeArea: 0,
        CodeApplication: 0,
      },
      module_list: [],
      action_list: [],
      selected_actions_list: [],
      applications: [],
      areas: [],
      areasFiltered: [],
      selected_action: null,
      pOpened: null,
      module: {
        Name: null,
        Description: null,
        Actions: [],
        IsInterfaceView: false,
        IsIntegrationAccess: false,
        Application: {
          Code: null,
        },
        Area: {
          Code: null,
        },
      },
      isSeeing: false,
      validatedModuleForm: false,
      validatedActionForm: false,
    };
  },
  computed: {
    Areas: function () {
      return this.$options.filters.orderBy(this.areas, "Name");
    },
    Modules() {
      return this.module_list;
    },
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListAccessControl();
    },
    "pagination.RowsPerPage": function () {
      this.ListAccessControl();
    },
    "module.Application.Code": function () {
      this.FilterAreas(this.module.Application.Code);
    },
    "filter.CodeApplication": function () {
      this.FilterAreas(this.filter.CodeApplication);
    },
  },
  mounted() {
    this.ListAccessControl();
    this.ListApplication();
    this.ListArea();
    this.ListAccessAction();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListAccessControl();
    },
    AddAction: function () {
      this.validatedActionForm = true;

      this.$refs.ActionsValidationForm.validate().then((isValid) => {
        if (isValid) {
          const selected = this.selected_action; // Action Code

          if (selected == null) {
            return;
          }
          // Search for duplicates
          let index = this.module.Actions.map((e) => {
            return e.Code;
          }).indexOf(selected);

          if (index == -1) {
            // Add if there's not duplicates
            let pos = this.action_list
              .map((e) => {
                return e.Code;
              })
              .indexOf(selected);
            this.module.Actions.push(this.action_list[pos]);
          } else {
            this.$refs.ActionsValidationForm.setErrors({
              selected_action: ["A ação já está atribuida ao módulo!"],
            });
          }
        }
      });
    },
    RemoveAction: function (Code) {
      let index = this.module.Actions.map((e) => {
        return e.Code;
      }).indexOf(Code);

      if (index > -1) {
        this.module.Actions.splice(index, 1);
      }
    },
    IsOnSelectedActionsList: function (actionCode) {
      let result = this.module.Actions.find((elm) => {
        return elm.Code == actionCode;
      });
      return result == undefined ? false : true;
    },
    ListAccessAction: function () {
      this.$store
        .dispatch("ListAccessAction", {})
        .then((response) => {
          this.action_list = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Verifique o retorno da API.",
            "warning",
            "Erro ao carregar a lista de ações",
            error
          );
        });
    },
    ListApplication: function () {
      this.$store
        .dispatch("ListApplication", { params: {} })
        .then((response) => {
          this.applications = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de aplicações",
            error
          );
        });
    },
    ListArea: function () {
      this.$store
        .dispatch("ListArea", { params: {} })
        .then((response) => {
          this.areas = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página",
            "danger",
            "Erro ao obter lista de áreas",
            error
          );
        });
    },
    ListAccessControl: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.CodeArea)) this.countFilter++;
      if (hasValue(this.filter.CodeApplication)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Area.Code": this.filter.CodeArea,
          "Object.Application.Code": this.filter.CodeApplication,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListAccessControl", { params: data })
        .then((response) => {
          this.module_list = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Verifique o retorno da API.",
            "warning",
            "Erro ao carregar a lista de módulos",
            error
          );
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    ResetFilter: function () {
      this.filter = {
        Name: null,
        CodeArea: 0,
        CodeApplication: 0,
      };
      this.ListAccessControl();
    },
    OpenMModule: function (e, id, view) {
      e.preventDefault();
      this.validatedModuleForm = false;
      this.validatedActionForm = false;
      this.loadingAddUpdate = false;

      this.selected_action = null;

      this.ResetModuleInfo();
      if (view == undefined && id != undefined) {
        // Edit
        this.modalTitle = "Editar módulo";
        this.pOpened = id;
        this.isSeeing = false;

        this.GetAccessControl(id);
      } else if (view == undefined && id == undefined) {
        // Add new
        this.modalTitle = "Novo Módulo";
        this.pOpened = null;
        this.isSeeing = false;

        this.ResetModuleInfo();
      } else {
        // View
        this.modalTitle = "Detalhes do módulo";
        this.pOpened = id;
        this.isSeeing = true;

        this.GetAccessControl(id);
      }

      this.$bvModal.show("mFormModule");
    },
    ResetModuleInfo: function () {
      this.module = {
        Name: null,
        Description: null,
        Actions: [],
        IsInterfaceView: false,
        IsIntegrationAccess: false,
        Application: {
          Code: null,
        },
        Area: {
          Code: null,
        },
      };
    },
    CreateOrUpdate: function () {
      this.validatedModuleForm = true;
      this.$refs.ControllerValidationForm.validate().then((isValid) => {
        if (isValid) {
          if (this.module.Actions.length < 1) {
            this.validatedActionForm = true;

            this.$refs.ActionsValidationForm.setErrors({
              selected_action: [
                "Você deve adicionar ao menos uma ação ao módulo!",
              ],
            });
            return;
          } else {
            this.isSeeing = true;
            this.loadingAddUpdate = true;

            if (this.pOpened == null) {
              // Add
              this.AddModule();
            } else {
              // Update
              this.UpdateModule();
            }
          }
        }
      });
    },
    GetAccessControl: function (id) {
      this.loadingModal = true;
      this.$store
        .dispatch("GetAccessControl", { id: id })
        .then((response) => {
          this.module = response;
        })
        .catch((error) => {
          this.$makeToast(
            "Verifique o retorno da API.",
            "warning",
            "Erro ao carregar módulo",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    AddModule: function () {
      this.$store
        .dispatch("AddAccessControl", { module: this.module })
        .then(() => {
          this.$makeToast(
            "O módulo foi cadastrado com sucesso.",
            "success",
            "Cadastrado!"
          );
          this.ListAccessControl();
          this.$bvModal.hide("mFormModule");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao cadastrar Módulo",
            error
          );
        })
        .finally(() => {
          this.isSeeing = false;
          this.loadingAddUpdate = false;
        });
    },
    UpdateModule: function () {
      this.$store
        .dispatch("UpdateAccessControl", { module: this.module })
        .then(() => {
          this.$makeToast(
            "O módulo foi atualizado com sucesso.",
            "success",
            "Atualizado!"
          );
          this.ListAccessControl();
          this.$bvModal.hide("mFormModule");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao atualizar módulo.",
            error
          );
        })
        .finally(() => {
          this.isSeeing = false;
          this.loadingAddUpdate = false;
        });
    },
    ProcessDelete: function (moduleName, moduleId) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover o módulo " + moduleName + "?",
        "Confirmar exclusão",
        this.DeleteModule,
        moduleId
      );
    },
    DeleteModule: function (moduleId) {
      this.$store
        .dispatch("DeleteAccessControl", { id: moduleId })
        .then(() => {
          this.$makeToast(
            "O módulo foi removido com sucesso.",
            "success",
            "Removido!"
          );
          this.ListAccessControl();
          this.$bvModal.hide("mFormModule");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover módulo.",
            error
          );
        });
    },
    FilterAreas: function (code) {
      this.areasFiltered = [];
      //let code = this.module.Application.Code;
      var newAreas = [];

      this.areas.find((elm) => {
        if (elm.Application.Code == code) newAreas.push(elm);
      });

      this.areasFiltered = newAreas;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/accessControls.vue